import React from "react";

const Textarea = ({ field, handleFieldChanged, type, value, showSimplifiedOptions, values = null }) => {
  console.log("textarea");

  let disbleDecision = false;

  if (field.hasOwnProperty("conditional")) {
    const segments = field.conditional.field.split("_");
    const fieldId = segments[segments.length - 1];

    if (values[fieldId] !== field.conditional.value) {
      disbleDecision = true;
      /* console.log("fieldId", fieldId);
      console.log("values", values[fieldId]); */
    }
  }

  return (
    <div className={field.hasOwnProperty("col") && field.col ? "medium-" + field.col : "medium-6"}>
      <div>
        {/* {field.hasOwnProperty("doNotDisplayLabel") &&
        field.doNotDisplayLabel === "yes" ? (
          ""
        ) : field.label ? (
          <label htmlFor={field._uid}>{field.label}</label>
        ) : (
          ""
        )} */}

        {field.hasOwnProperty("doNotDisplayLabel") && field.doNotDisplayLabel === "yes"
          ? ""
          : (showSimplifiedOptions === true &&
              field &&
              field.hasOwnProperty("simplifiedLabel") &&
              field.simplifiedLabel && <label htmlFor={field._uid}>{field.simplifiedLabel}</label>) ||
            (field && field.hasOwnProperty("label") && field.label && (
              <label htmlFor={field._uid}>{field.label}</label>
            ))}

        <textarea
          id={field._uid}
          name={field._uid}
          onChange={(e) => {
            // Notify the main state list of the new value
            handleFieldChanged(field._uid, e.target.value, field.resetFields);
          }}
          rows={field.textareaRows ? field.textareaRows : 1}
          maxLength={field.maxLength && field.maxLength}
          value={value}
          placeholder={(field.placeholder && field.placeholder) || ""}
          disabled={(disbleDecision === true && true) || false}
        />
      </div>
    </div>
  );
};

export default Textarea;
